import { ReactNode } from 'react';

import { ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { cn } from '@/lib/utils';

interface SidebarLayoutProps {
  /** Unique ID passed to ResizablePanelGroup to persist resize widths in localStorage. */
  autoSaveId: string;
  /** Main content rendered inside the left (order={1}) ResizablePanel. */
  children: ReactNode;
  /** One or more `<Sidebar>` / `<ResponsiveSidebarPanel>` elements. Each emits its own handle + panel. */
  sidebar: ReactNode;
  /** Class for the outer ResizablePanelGroup. */
  className?: string;
  /** Class for the inner main ResizablePanel. */
  mainClassName?: string;
}

/**
 * Layout wrapper that pairs a main content area with one or more sidebars.
 * Encapsulates the ResizablePanelGroup + `order={1}` main panel boilerplate
 * that used to be duplicated across every page with a right-side sidebar.
 */
export const SidebarLayout = ({
  autoSaveId,
  children,
  sidebar,
  className,
  mainClassName,
}: SidebarLayoutProps) => (
  <ResizablePanelGroup
    direction="horizontal"
    autoSaveId={autoSaveId}
    className={cn('h-full w-full bg-bg-muted-light', className)}
  >
    <ResizablePanel
      order={1}
      className={cn('flex min-h-0 flex-col overflow-hidden bg-bg-muted-light', mainClassName)}
    >
      {children}
    </ResizablePanel>
    {sidebar}
  </ResizablePanelGroup>
);
